$(document).ready(function () {
	$(document).on('click', '.vg-reviews-item .read-more', function () {
		let $item = $(this).closest('.vg-reviews-item');

		$(this).hide();

		$item.find('.short').hide();
		$item.find('.full').show();

		return false;
	});
});